import type { Variables, ComponentConstructor, BaseComponentConfig, JXGBoard } from '../types/interfaces';
import { DiagramComponent } from './DiagramComponent';

/**
 * Registry for component type -> class mapping
 * Allows declarative instantiation from JSON
 */
class ComponentRegistry {
  components: Map<string, ComponentConstructor>;

  constructor() {
    this.components = new Map();
  }

  /**
   * Register a component class
   */
  register(type: string, componentClass: ComponentConstructor): void {
    this.components.set(type, componentClass);
  }

  /**
   * Create component instance from config
   */
  create(config: BaseComponentConfig, board: JXGBoard, parentState: Variables = {}): DiagramComponent | null {
    const ComponentClass = this.components.get(config.type);

    if (!ComponentClass) {
      console.warn(`Unknown component type: ${config.type}`);
      return null;
    }

    return new ComponentClass(config, board, parentState) as DiagramComponent;
  }

  /**
   * Check if type is registered
   */
  has(type: string): boolean {
    return this.components.has(type);
  }

  /**
   * Get component class by type
   */
  get(type: string): ComponentConstructor | undefined {
    return this.components.get(type);
  }

  /**
   * Get all registered types
   */
  getTypes(): string[] {
    return Array.from(this.components.keys());
  }
}

// Singleton instance
export const componentRegistry = new ComponentRegistry();

// Export class for testing
export { ComponentRegistry };
